// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { addMonthlyInfoImage, deleteMonthlyInfoImage, fetchMonthlyInfoImages } from './imagesQueries'
import get from 'lodash/get'
import Loader from '../../../common/loader/Loader'
import { Button, Typography } from '@mui/material'
import { i18n } from '../../index'
import css from './images.css'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import type { User } from '../../auth/types'
type ImageTypes = 'monthlyinfo_manager' | 'monthlyinfo_hall' | 'monthlyinfo_kitchen'
type ImagesProps = {
  stationId: string
  selectImage: (...args: Array<any>) => any
  user: User
  imageType: ImageTypes
}

const Images = ({ stationId, selectImage, user, imageType }: ImagesProps) => {
  let inputRef = null

  const convertImageAndSubmit = async (e: Event, onMutate: (...args: Array<any>) => any, stationId: string) => {
    e.persist()
    const isSokAdmin = user.userType === 'SokAdmin'

    if (e.target.files[0]) {
      const file = e.target.files[0]

      if (file.size <= 2000000) {
        const base64file = await fileToBase64(file)
        onMutate({
          variables: {
            stationId: isSokAdmin ? null : stationId,
            type: imageType,
            file: base64file,
          },
        })
        inputRef.value = ''
      }
    }
  }

  const fileToBase64 = (file: File) => {
    return new Promise((resolve) => {
      const reader = new FileReader()

      reader.onload = (event) => {
        if (event.target) {
          resolve(event.target.result)
        }
      }

      // Convert data to base64
      reader.readAsDataURL(file)
    })
  }

  const deleteImage = (onMutate: (...args: Array<any>) => any, imageId: string) => {
    onMutate({
      variables: {
        imageId,
      },
    })
  }

  const setInputRef = (el) => (inputRef = el)

  const onImageButtonClick = () => {
    if (inputRef) inputRef.click()
  }

  return (
    <div className={css.component}>
      <Query
        query={fetchMonthlyInfoImages}
        variables={{
          stationId,
          type: imageType,
        }}
      >
        {({ loading, error, data }) => {
          const images = get(data, 'images', [])
          return (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <Typography variant='h6' gutterBottom>
                {i18n.t('monthlyInfo.title.images')}
              </Typography>
              {images && images.length > 0 && (
                <div className={css.images}>
                  {images.map((image, i) => {
                    const userIsSokAdmin = user.userType === 'SokAdmin'
                    const canDelete = image.station !== null || userIsSokAdmin
                    return (
                      <div key={i} className={css.imageContainer}>
                        <div className={css.image} onClick={() => selectImage(image.content)}>
                          <img src={image.content} alt={''} />
                        </div>
                        <div className={css.imageActions}>
                          {canDelete && (
                            <Mutation
                              mutation={deleteMonthlyInfoImage}
                              refetchQueries={[
                                {
                                  query: fetchMonthlyInfoImages,
                                  variables: {
                                    stationId,
                                    type: imageType,
                                  },
                                },
                              ]}
                            >
                              {(onMutate) => <DeleteButton onClick={() => deleteImage(onMutate, image.id)} />}
                            </Mutation>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </Loader>
          )
        }}
      </Query>

      <Mutation
        mutation={addMonthlyInfoImage}
        refetchQueries={[
          {
            query: fetchMonthlyInfoImages,
            variables: {
              stationId,
              type: imageType,
            },
          },
        ]}
      >
        {(onMutate) => (
          <form noValidate>
            <div className={css.imageInputContainer}>
              <Button
                onClick={onImageButtonClick}
                color={'primary'}
                variant='contained'
                className={css.imageInputButton}
              >
                {i18n.t('monthlyInfo.button.addImage')}
              </Button>
              <input
                ref={setInputRef}
                className={css.imageInput}
                type={'file'}
                onChange={(e) => convertImageAndSubmit(e, onMutate, stationId)}
              />

              <p className={css.imageNoteText}>{i18n.t('monthlyInfo.title.imageRestrictions')}</p>
            </div>
          </form>
        )}
      </Mutation>
    </div>
  )
}

export default Images
